import { RoleEnum } from "../../types/RoleEnum";
export var REPORTS_CONFIG = [
    {
        id: "550e8400-e29b-41d4-a716-446655440001",
        key: "progress-report",
        translationKey: "ui-br-agency.outputs.report.progress-report",
        allowedRoles: [RoleEnum.AGENCY_WORKER],
    },
    {
        id: "550e8400-e29b-41d4-a716-446655440002",
        key: "identifier-report",
        translationKey: "ui-br-agency.outputs.report.identifier-report",
        allowedRoles: [
            RoleEnum.AGENCY_WORKER,
            RoleEnum.PUBLISHER_GUARANTOR,
            RoleEnum.PUBLISHER_ADMIN,
        ],
    },
    {
        id: "550e8400-e29b-41d4-a716-446655440003",
        key: "piid-report",
        translationKey: "ui-br-agency.outputs.report.piid-report",
        allowedRoles: [RoleEnum.AGENCY_WORKER],
    },
    {
        id: "550e8400-e29b-41d4-a716-446655440006",
        key: "annual-report",
        translationKey: "ui-br-agency.outputs.report.annual-report",
        allowedRoles: [RoleEnum.AGENCY_WORKER],
    },
    {
        id: "550e8400-e29b-41d4-a716-446655440007",
        key: "sckn-report",
        translationKey: "ui-br-agency.outputs.report.sckn-report",
        allowedRoles: [RoleEnum.AGENCY_WORKER],
    },
    {
        id: "550e8400-e29b-41d4-a716-446655440008",
        key: "kult-15-01",
        translationKey: "ui-br-agency.outputs.report.kult-15-01",
        allowedRoles: [RoleEnum.AGENCY_WORKER],
    },
    {
        id: "550e8400-e29b-41d4-a716-446655440005",
        key: "nipos-report",
        translationKey: "ui-br-agency.outputs.report.nipos-report",
        allowedRoles: [RoleEnum.AGENCY_WORKER],
    },
    {
        id: "550e8400-e29b-41d4-a716-446655440009",
        key: "ipa-report",
        translationKey: "ui-br-agency.outputs.report.ipa-report",
        allowedRoles: [RoleEnum.AGENCY_WORKER],
    },
    {
        id: "550e8400-e29b-41d4-a716-446655440010",
        key: "wipo-report",
        translationKey: "ui-br-agency.outputs.report.wipo-report",
        allowedRoles: [RoleEnum.AGENCY_WORKER],
    },
    {
        id: "550e8400-e29b-41d4-a716-446655440011",
        key: "performance-statistics",
        translationKey: "ui-br-agency.outputs.report.performance-statistics",
        allowedRoles: [RoleEnum.AGENCY_WORKER],
    },
    {
        id: "550e8400-e29b-41d4-a716-446655440004",
        key: "onix-export",
        translationKey: "ui-br-agency.outputs.report.onix-export",
        allowedRoles: [RoleEnum.AGENCY_WORKER],
    },
];
export var getReportByKey = function (key) {
    return REPORTS_CONFIG.find(function (report) { return report.key === key; });
};
